import React, { FC, useState, useEffect } from 'react';
import { SelfcareCustomerDto } from '../API';
import { Flex, Heading, Spinner } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { ServiceLinks } from './ServiceLinks';
import { CustomerApi } from '../API/sdk';

export const UserServicesPage: FC = (props) => {
	const { t } = useTranslation('common');
	const [customer, setCustomer] = useState<null | SelfcareCustomerDto>(null);
	const [pending, setPending] = useState(false);

	const updateCustomer = async () => {
		setPending(true);
		const result = await CustomerApi.getSelfcareCustomerServices();
		result.data && setCustomer(result.data);
		setPending(false);
	};

	useEffect(() => {
		updateCustomer();
	}, []);

	return (
		<div>
			<Heading as="h2" fontSize="lg" fontWeight={400}>
				{t('SERVICE_WELCOME')}
			</Heading>

			{pending && (
				<Flex mt={3} p={3} bg="blue.50" borderRadius={4}>
					<Spinner mr={4} /> {t('FETCHING_SERVICES_NOTIFICATION')}
				</Flex>
			)}
			{!pending && customer !== null && <ServiceLinks customerServices={customer.services} />}
		</div>
	);
};
